import React from "react";
import { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { useSelector, useDispatch } from "react-redux";
import { setZoom } from "../../slices/cropTools";
import "./ImageCropper.css";

function ImageCropper({ setCroppedAreaPixels, inputImgURL }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const zoom = useSelector((state) => state?.crop?.zoom);
  // const [zoom, setZoom] = useState(1);
  const dispatch = useDispatch();

  //   const imgURL = URL.createObjectURL(inputImg);
  const imgURL = inputImgURL;

  const onCropComplete = async (_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  return (
    <div className="cropper">
      <Cropper
        image={imgURL}
        crop={crop}
        zoom={zoom}
        aspect={1}
        showGrid={false}
        cropShape="round"
        // disableAutomaticStylesInjection={true}
        // classes={{
        //   containerClassName: "crop-container",
        //   mediaClassName: "crop-media",
        //   cropAreaClassName: "crop-area",
        // }}
        onCropChange={setCrop}
        onCropComplete={onCropComplete}
        onZoomChange={(e) => {
          dispatch(setZoom(e));
        }}
      />
    </div>
  );
}

export default ImageCropper;
